import type { ElementType } from '../model/form.types';

const RULES_NON_SELECTABLE_TYPES = new Set<ElementType>(['HEADER', 'TABLE', 'FIXED_TEXT']);

export function isRulesSelectableType(type: ElementType): boolean {
  return !RULES_NON_SELECTABLE_TYPES.has(type);
}
